import styled from 'styled-components';

export const ContainerInfos = styled.div`
  padding: 8px;
  width: 100%;
`;

export const ContainerCardBoletos = styled.div`
  display: flex;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  background-color: #fff;
  padding: 8px;
  color: #4d4d4d;
  margin-top: 20px;
  display: none;

  .boletoIcone {
    box-sizing: border-box;
    height: 36px;
    min-width: 36px;
    padding: 4px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-color: ${(props) =>
      !props.atrasada
        ? props.tema.primaryColor
        : props.pagamentoProcessando
        ? '#d1d1d1'
        : 'rgb(186, 18, 43)'};
    svg {
      & * {
        fill: #fff !important;
      }
    }
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const HeaderCardBoleto = styled.div`
  .infosHeaderCardBoleto {
    width: 100%;
    display: block;

    .containerIconTitle {
      display: flex;
      width: 100%;
      align-items: center;
      gap: 16px;
    }

    .containerVencValor {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;

      > div:nth-child(2) {
        span {
          text-align: right;
        }
      }
    }

    .containerContrato {
      margin-top: 12px;
      margin-bottom: 16px;
      span:nth-child(2) {
        font-size: 12px;
      }
    }

    span {
      display: block;
      color: #4d4d4d;
      &:nth-child(1) {
        font-size: 12px;
        margin-bottom: 4px;
      }

      &:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
      }

      &.description {
        font-size: 16px;
      }

      &.dataVencimento {
        color: ${(props) => (!props.atrasada ? '#4d4d4d' : 'rgb(186, 18, 43)')};
      }

      &.processandoPagamento {
        color: ${(props) => props?.tema?.primaryColor};
        font-size: 16px;
        font-weight: bold;
        width: 100%;
      }

      &.processandoPagamentoPixSubtitle {
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
`;

export const BodyCardBoleto = styled.div`
  margin-top: 8px;

  .titleContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    padding: 8px 0px;
    text-align: center;
    font-size: 12px;

    box-sizing: border-box;
  }

  .content {
    width: 100%;
  }

  .card {
    display: flex;
    flex-direction: column;
    margin: 12px auto;
    border: 1px solid #d1d1d1;
    padding: 8px;
    border-radius: 4px;
  }

  .cardTitle {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 8px;
  }

  .numberRow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: #0249d033;
    color: #0047ba;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    box-sizing: border-box;
    font-weight: bold;
    font-size: 12px;
  }

  .parcela {
    display: flex;
    flex-direction: column;
    span:nth-child(1) {
      font-size: 12px;
      margin-bottom: 4px;
    }
    span:nth-child(2) {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .cardBody {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-top: 8px;

    .parcela:nth-of-type(2) {
      span {
        text-align: right;
      }
    }
  }

  .divider {
    width: calc(100% + 32px);
    position: relative;
    left: -16px;
    height: 1px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 16px;

  .info-text {
    display: block;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 16px;
    margin-top: 8px;
  }
  .container-buttons-boleto > div,
  .container-buttons-pagamento > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .container-buttons-pagamento {
    margin-top: 8px;
  }
`;
